"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDatePicker = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DatePickerMixin = require("../../mixins/components/DatePickerMixin");
var StyledDatePicker = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledDatePicker",
  componentId: "c11n-8-107-0__sc-5rr0yu-0"
})(["", ""], _DatePickerMixin.DatePickerMixin);
exports.StyledDatePicker = StyledDatePicker;